import React, { createContext, useState, useContext, useEffect } from 'react';
import { ApiClient } from '../api/api-client';

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({});
  const [initialized, setInitialized] = useState(false);
  
  function isAuthorized(acl) {
    if (acl === null || acl === undefined) {
      return false;
    }
    return config?.user?.privileges?.some((privilege) => privilege.name === acl) ?? false;
  }

  function isCompanyManager(userRecord) {
    if (userRecord.companyId) { // User is part of a company
      if ( config.user.companyManager && config.user.companyId === userRecord.companyId ) { // Session user is owner of that company
        return true;
      }
    }
    
    return false;
  }

  function refresh() {
    const fetchUser = () => ApiClient.getInstance().getSession()
      .then((res) => {
        setConfig({ user: res.data })
      })
      .catch(() => {
        console.error('Error fetching user data');
      });

    fetchUser();
  }

  useEffect(() => {
    const fetchUser = () => ApiClient.getInstance().getSession()
      .then((res) => {
        setConfig({ user: res.data })
      })
      .catch(() => {
        console.error('Error fetching user data');
      });

    setInitialized(true);    
    fetchUser();
  }, []);

  return initialized ? (
    <ConfigContext.Provider value={{
      config,
      isAuthorized,
      isCompanyManager,
      refresh
    }}>
      {children}
    </ConfigContext.Provider>
  ) : null;
};

export const useConfig = () => useContext(ConfigContext);